<div class="tier-editor" [class.is-bad]="!ordered || (showPoints && !pointsOrdered)">
  <label class="direction">
    <span class="p-hidden-accessible">Dirección de {{ label }}</span>
    <select
      class="p-inputtext"
      [disabled]="readonly"
      [ngModel]="direction"
      (ngModelChange)="setDirection($event)"
      data-test="tier-direction"
    >
      <option value="higher_better">Más es mejor</option>
      <option value="lower_better">Menos es mejor</option>
    </select>
  </label>
  <label class="tier" *ngFor="let key of keys">
    <span class="tier-points" *ngIf="!showPoints || key === 't20' || readonly">{{ points[key] }} pts</span>
    <span class="tier-points tier-points--edit" *ngIf="showPoints && key !== 't20' && !readonly">
      <input
        class="p-inputtext"
        type="number"
        min="0"
        max="20"
        step="any"
        [ngModel]="points[key]"
        (ngModelChange)="setPoints($any(key), $event)"
        [attr.aria-label]="label + ': puntos del tramo ' + (key === 't15' ? 'medio' : 'bajo')"
        [attr.data-test]="'points-' + key"
      />
      pts
    </span>
    <span class="tier-input">
      <input
        class="p-inputtext"
        type="number"
        step="any"
        [readonly]="readonly"
        [ngModel]="shown(key)"
        (ngModelChange)="setTier(key, $event)"
        [attr.aria-label]="label + ': umbral del tramo de ' + points[key] + ' puntos'"
        [attr.data-test]="'tier-' + key"
      />
      <span class="tier-suffix" *ngIf="suffix">{{ suffix }}</span>
    </span>
  </label>
  <small class="order is-bad" *ngIf="showPoints && !pointsOrdered" data-test="points-order">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i> Los puntos tienen que bajar de tramo en tramo (20 ≥ medio ≥ bajo ≥ 0).
  </small>
  <button
    *ngIf="showPoints && customPoints && !readonly"
    type="button"
    class="points-reset"
    (click)="resetPoints()"
    data-test="points-reset"
  >
    Restablecer 20 / 15 / 10
  </button>
  <small class="order" [class.is-bad]="!ordered" data-test="tier-order">
    <i class="pi" [class.pi-exclamation-triangle]="!ordered" [class.pi-sort-alt]="ordered" aria-hidden="true"></i>
    {{ ordered ? orderHint : 'No van en orden. ' + orderHint }}
  </small>
</div>
